import * as React from 'react';

import { cn } from '@/lib/utils';

interface AIBadgeProps {
    children?: React.ReactNode;
    className?: string;
}

const badgeClasses = cn(
    'inline-flex items-center gap-1 rounded-md font-sans',
    'bg-[length:200%_200%] bg-gradient-to-r from-[#0a2a8a] via-[#2e6fe8] to-[#62e3ff]',
    'text-[11px] font-semibold text-white',
    'shadow-[0_8px_18px_rgba(46,111,232,0.35)]',
    'animate-gradient-shift',
);

function AIBadge({ children = 'IA', className }: AIBadgeProps) {
    return <span className={cn(badgeClasses, 'px-2 py-1', className)}>{children}</span>;
}

export { AIBadge };
export type { AIBadgeProps };
